export default {
  GET_SECURITY_DEVICES: 'GET_SECURITY_DEVICES',
  GET_SECURITY_DEVICES_SUCCESS: 'GET_SECURITY_DEVICES_SUCCESS',
};
